// 对账
import reconciliat from './modules/reconciliation';
// 差错对账
import error from './modules/error';

const financial = {
  reconciliat,
  error,
};

export default financial;
